import { GoogleLogin as ReactGoogleLogin } from '@react-oauth/google';
import { useAuth } from '../../contexts/AuthContext';
import { verifyGoogleToken } from '../../services/auth';

const GoogleLogin = () => {
  const { login } = useAuth();

  const handleGoogleSuccess = async (credentialResponse: any) => {
    try {
      console.log('Google login success:', credentialResponse);
      
      // Make sure we have a credential
      if (!credentialResponse.credential) {
        console.error('No credential received from Google');
        return;
      }
      
      // Call our backend to verify the token
      console.log('Verifying token with backend...');
      const { user } = await verifyGoogleToken(credentialResponse.credential);
      
      console.log('User data received:', user);
      login(user);
    } catch (error) {
      console.error('Google login failed:', error);
    }
  };

  const handleGoogleError = () => {
    console.error('Google login failed');
  };

  return (
    <div className="google-login-container">
      <ReactGoogleLogin
        onSuccess={handleGoogleSuccess}
        onError={handleGoogleError}
        useOneTap={false}
        width="250"
      />
    </div>
  );
};

export default GoogleLogin; 